export const MASK = new Array(19).fill(/\d/);
